import { jsx as _jsx } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend';
import './Component_SL_Icon.scss';
export const Component_SL_Icon = (p) => {
    const className = _className('csl-icon', p.variant ?? 'round');
    return _jsx("div", { className: className, style: { width: p.width ?? 16 } });
};
//# sourceMappingURL=Component_SL_Icon.js.map